import { render, staticRenderFns } from "./fund-requests.vue?vue&type=template&id=fea9f352&"
import script from "./fund-requests.vue?vue&type=script&lang=js&"
export * from "./fund-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports